var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pending" }, [
    _c("img", { attrs: { src: _vm._f("prefixOssUrl")("empty.png") } }),
    _c("div", [_vm._v("区域查询暂未开放，请联系信息部！")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }